import { render, staticRenderFns } from "./SkuStockShow.vue?vue&type=template&id=92dc6b22"
import script from "./SkuStockShow.vue?vue&type=script&lang=js"
export * from "./SkuStockShow.vue?vue&type=script&lang=js"
import style0 from "./SkuStockShow.vue?vue&type=style&index=0&id=92dc6b22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports